<form [formGroup]="editRentalBookingForm" (keydown.enter)="$event.preventDefault()">
    <div class="boxBColor shadow-md pr-2 py-2 rounded-xl">
        <div class="flex justify-between items-center">
            <div class="w-full mx-auto px-3">
                <div class="w-full" [ngStyle]="{'margin-left': '5px'}">
                    <div class="cd-btn main-action custom-input-icon-left w-full mb-1">
                        <div class="input-icon-left">
                            <i class="fas fa-map-marker-alt text-green-700 text-xl"></i>
                        </div>
                        <input type="search" name="editRentalPickup" id="editRentalPickup"
                            (keyup)="autoCompleteSearch1($event)"
                            (blur)="autoCompleteSearch1($event,'focusOut','pickup')" spellcheck="false"
                            formControlName="pickupPoint" autofocus="true" [matAutocomplete]="editPickup"
                            [attr.disabled]="(isRentalEnabledEditBooking == false || isActiveBooking == true)?true:null" />
                        <span>Enter pickup point address</span>
                        <div style="clear: both;"></div>
                        <mat-autocomplete #editPickup="matAutocomplete" class="overflow-auto journal-scroll">
                            <mat-option class="h-auto" *ngFor="let option  of editJobAddressList"
                                [value]="option.title+', '+option.address"
                                (onSelectionChange)="autoCompleteEnterText($event,option,'pickup')">
                                <div class="flex flex-row">
                                    <div class="w-auto mr-3">
                                        <i class="fas fa-map-pin fontColor text-3xl"></i>
                                    </div>
                                    <div
                                        class="flex flex-col justify-center createJobAddressListTitile w-11/12 truncate">
                                        <h4
                                            class="text-md fontColor fontMedium text-black truncate autocomplete-head-label">
                                            {{option.title}}
                                        </h4>
                                        <p
                                            class="text-xl fontColor text-gray-800 truncate m-0 fontMedium autocomplete-sub-label">
                                            {{option.address}}
                                        </p>
                                    </div>
                                </div>
                            </mat-option>
                        </mat-autocomplete>
                    </div>
                </div>

            </div>
        </div>

        <div class="justify-start items-end mb-2 ml-2 w-full -mt-1">
            <div class=" flex flex-col mx-auto px-3">
                <label class="ml-2 mb-0 fontMediumBold"> Select Package </label>
                <div class="flex flex-row">
                    <select name="selectedPackage"
                        [disabled]="isRentalEnabledEditBooking == false || isActiveBooking == true"
                        (change)="newRidePackageChange($event)"
                        class="border custom-select custom-font-md w-full boxBColor rounded-full p-2 px-3 scroller custom-select overflow-auto journal-scroll h-12">
                        <option *ngFor="let package of packagesArray" [value]="package.packageId"
                            [selected]="package.packageHours == packageHours">
                            {{package.packageHours}} hours {{package.packageKm ? package.packageKm : '0'}} Km
                        </option>
                    </select>
                </div>
            </div>

            <div class="text-start autocomplete-sub-label ml-10 mb-1 mt-2 fontMedium flex inline-flex align-center">
                <div>
                    <span>Route : </span>
                    <span>{{editJobCurrency}} {{editRideTotal}} Price </span>
                </div>
                <div class="flex inline-block ml-1" *ngIf="editJobSurgeMultiplier != 1">
                    <span> | {{editJobSurgeMultiplier}}X Surges </span>
                    <img *ngIf="editJobSurgeMultiplier > 1" src="../../assets/images/surge_up.gif" class="h-8 ml-2"
                        alt="" srcset="">
                    <img *ngIf="editJobSurgeMultiplier < 1" src="../../assets/images/surge_down.gif" class="h-8 ml-2"
                        alt="" srcset="">
                </div>
            </div>

            <div class="boxBColor">
                <div class="w-full mx-auto px-3 py-1">
                    <div class="cd-btn main-action custom-input w-full mb-2">
                        <input type="search" name="info" id="info" spellcheck="false" required
                            [attr.disabled]="isRentalEnabledEditBooking == false?true:null"
                            formControlName="editJobUserComment" autocomplete="off" />
                        <span>Info (all):</span>
                        <div style="clear: both;"></div>
                    </div>
                    <div class="custom-input w-full mt-2">
                        <input type="search" name="info" id="info" spellcheck="false" required
                            [attr.disabled]="isRentalEnabledEditBooking == false?true:null"
                            formControlName="editJobDriverComment" autocomplete="off" />
                        <span>Info (Driver):</span>
                        <div style="clear: both;"></div>
                    </div>
                </div>
            </div>

            <div *ngIf="editJobShowRentInfo == true" class="boxBColor mt-0">
                <div class="px-6 w-full flex text-center justify-start">
                    <span class="fontColor text-xl mb-2 ml-3 capitalize fontMediumBold">
                        <i class="far fa-calendar-alt mr-2"></i>When </span>
                    <div class="flex text-center justify-center ml-2">
                        <div class="flex justify-between flex-row text-center align-center items-center -mt-1">
                            <div class="flex items-center">
                                <label for="now" class="btn-radio flex items-end">
                                    <input type="radio" id="now"
                                        [disabled]="isRentalEnabledEditBooking == false || isActiveBooking == true"
                                        (change)="newJobWhenRide('now')" [checked]="editRideOptionStatus"
                                        class="loginThemeSwitch hidden" name="nowLaterBooking" />
                                    <svg width="1.25rem" class="mt-0" height="1.125rem" viewBox="0 0 20 20">
                                        <circle cx="10" cy="10" r="9"></circle>
                                        <path
                                            d="M10,7 C8.34314575,7 7,8.34314575 7,10 C7,11.6568542 8.34314575,13 10,13 C11.6568542,13 13,11.6568542 13,10 C13,8.34314575 11.6568542,7 10,7 Z"
                                            class="inner"></path>
                                        <path
                                            d="M10,1 L10,1 L10,1 C14.9705627,1 19,5.02943725 19,10 L19,10 L19,10 C19,14.9705627 14.9705627,19 10,19 L10,19 L10,19 C5.02943725,19 1,14.9705627 1,10 L1,10 L1,10 C1,5.02943725 5.02943725,1 10,1 L10,1 Z"
                                            class="outer"></path>
                                    </svg>
                                    <div class="darkfontColor custom-font-md ml-2">
                                        Now
                                    </div>
                                </label>
                            </div>
                            <label for="later" class="btn-radio flex items-end">
                                <input type="radio" id="later"
                                    [disabled]="isRentalEnabledEditBooking == false || isActiveBooking == true"
                                    (change)="newJobWhenRide('later')" [checked]="!editRideOptionStatus"
                                    name="nowLaterBooking" />
                                <svg width="1.25rem" height="1.125rem" class="mt-0" viewBox="0 0 20 20">
                                    <circle cx="10" cy="10" r="9"></circle>
                                    <path
                                        d="M10,7 C8.34314575,7 7,8.34314575 7,10 C7,11.6568542 8.34314575,13 10,13 C11.6568542,13 13,11.6568542 13,10 C13,8.34314575 11.6568542,7 10,7 Z"
                                        class="inner"></path>
                                    <path
                                        d="M10,1 L10,1 L10,1 C14.9705627,1 19,5.02943725 19,10 L19,10 L19,10 C19,14.9705627 14.9705627,19 10,19 L10,19 L10,19 C5.02943725,19 1,14.9705627 1,10 L1,10 L1,10 C1,5.02943725 5.02943725,1 10,1 L10,1 Z"
                                        class="outer"></path>
                                </svg>
                                <div class="darkfontColor custom-font-md ml-2">
                                    Later
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="flex justify-center items-end mb-2 w-full -mt-1" [hidden]="editRideOptionStatus">
                    <div class=" flex flex-col">
                        <label class="ml-2 mb-0"> Date </label>
                        <div class="flex flex-row mr-2">
                            <select name="laterHours"
                                [attr.disabled]="(isRentalEnabledEditBooking == false || isActiveBooking == true)?true:null"
                                (change)="newRideLaterHoursChange($event)" formControlName="editRideSelectedHours"
                                class=" border custom-select custom-font-md w-28 boxBColor rounded-full p-2 px-3 scroller  custom-select overflow-auto journal-scroll h-12">
                                <option *ngFor="let hours of hoursArray" [value]="hours">
                                    {{hours}}</option>
                            </select>
                            <select name="laterMinutes"
                                [attr.disabled]="(isRentalEnabledEditBooking == false || isActiveBooking == true)?true:null"
                                (change)="newRideLaterMinuteChange($event)" formControlName="editRideSelectedMinute"
                                class="  ml-3 boxBColor w-28 custom-font-md rounded-full p-2 px-3 scroller  custom-select overflow-auto journal-scroll h-12">
                                <option *ngFor="let minutes of minutesArray" [value]="minutes">
                                    {{minutes}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="mx-2 ml-2 relative">
                        <input type="text" autocomplete="off" name="datePickerSearchJob"
                            [disabled]="isRentalEnabledEditBooking == false"
                            class="  rounded-full boxBColor px-4 custom-font-md p-2 relative outline-none focus:outline-none custom-select w-56 h-12 md:w-full sm:w-full"
                            ngxDaterangepickerMd formControlName="editBookingCalenderModel"
                            [showCustomRangeLabel]="false" startKey="start" endKey="end" [locale]="{format:dateFormat}"
                            [minDate]="setEditMinDate" (datesUpdated)="newRideDateChange($event)"
                            [alwaysShowCalendars]="true" [linkedCalendars]="true" [singleDatePicker]="true"
                            [showClearButton]="true" placeholder="Select Date" />
                    </div>
                    <div class="flex flex-col ml-2">
                        <label class="ml-1 mb-0" for="assignTime">Assign
                            Time</label>
                        <select name="editAssignTime"
                            [attr.disabled]="(isRentalEnabledEditBooking == false || isActiveBooking == true)?true:null"
                            formControlName="editRideSelectedAssignTime"
                            class=" p-2 custom-select boxBColor custom-font-md  rounded-full scroller custom-select overflow-auto journal-scroll w-44 h-13">
                            <option value="0"> 0 {{ "min" }} </option>
                            <option value="5" selected> 5 {{ "min" }} </option>
                            <option value="10"> 10 {{ "min" }} </option>
                            <option value="15"> 15 {{ "min" }} </option>
                            <option value="20"> 20 {{ "min" }} </option>
                            <option value="30"> 30 {{ "min" }} </option>
                            <option value="45"> 45 {{ "min" }} </option>
                            <option value="60"> 1 {{ "h" }} 00 {{ "min" }}
                            </option>
                            <option value="75"> 1 {{ "h" }} 15 {{ "min" }}
                            </option>
                            <option value="90"> 1 {{ "h" }} 30 {{ "min" }}
                            </option>
                            <option value="120"> 2 {{ "h" }} 00 {{ "min" }}
                            </option>
                            <option value="150"> 2 {{ "h" }} 30 {{ "min" }}
                            </option>
                            <option value="180"> 3 {{ "h" }} 00 {{ "min" }}
                            </option>
                            <option value="210"> 3 {{ "h" }} 30 {{ "min" }}
                            </option>
                            <option value="240"> 4 {{ "h" }} 00 {{ "min" }}
                            </option>
                            <option value="270"> 4 {{ "h" }} 30 {{ "min" }}
                            </option>
                            <option value="300"> 5 {{ "h" }} 00 {{ "min" }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div class="animate-pulse px-4 py-3 mt-2" *ngIf="editJobShowRentInfo == false && showRentShimmer == false">
            <div class="col-span-6 sm:col-span-6">
                <div class="mt-2 flex fontMediumBold h-14">
                    <div class="w-full h-14 bg-gray-300 bg-opacity-75 rounded-full mb-2">
                    </div>
                </div>
            </div>

            <div class="grid px-8 w-full mt-4">
                <span class="w-28 h-6 bg-gray-300 bg-opacity-75 rounded mb-2"></span>
                <div class="w-3/4 h-14 bg-gray-300 bg-opacity-75 rounded-full mb-2">
                </div>
            </div>
        </div>
        <div class="flex shadow-md boxBColor p-2 pb-2 rounded-xl mt-2">
            <div class="w-full">
                <div>
                    <div class="boxBColor mt-2 mb-2 rounded-lg shadow-md">
                        <div class="pl-3 pr-2 py-2">
                            <div class="cd-btn main-action custom-input-icon-2 w-full mt-2 h-14">
                                <div class="input-icon-left">
                                    <i class="bx bx-hash text-2xl"></i>
                                </div>
                                <input type="text" name="accountId" id="accountId" formControlName="accountId"
                                    (keyup)="newRideforPassenger($event)" autocomplete="off"
                                    [matAutocomplete]="editJobAccountList"
                                    [attr.disabled]="isRentalEnabledEditBooking == false?true:null" spellcheck="false"
                                    required />
                                <span>Account Id</span>
                                <div class="input-icon-right">
                                    <i class="bx bx-search-alt text-2xl"></i>
                                </div>

                                <mat-autocomplete #editJobAccountList="matAutocomplete"
                                    class="overflow-auto journal-scroll">
                                    <mat-option class="h-auto" *ngFor="let accountItem of editJobAccountDataList;"
                                        [value]="accountItem.userAccountId"
                                        
                                        (onSelectionChange)="accountDetails(accountItem)">
                                        <div class="flex flex-col justify-center w-11/12 truncate py-2">
                                            <h4 class="text-xl fontColor font-bold">
                                                {{accountItem.userAccountId}}
                                            </h4>
                                            <p
                                                class="text-xl fontColor text-gray-800 truncate m-0 fontMedium autocomplete-sub-label">
                                                {{accountItem.userName}}
                                                (+{{accountItem.userMobile}})
                                            </p>
                                        </div>
                                    </mat-option>
                                </mat-autocomplete>
                                <div style="clear: both;"></div>
                            </div>

                            <div class="grid grid-cols-6 gap-6">
                                <div class="col-span-6 sm:col-span-3">
                                    <div class="cd-btn main-action custom-input-icon-2 w-full">
                                        <div class="input-icon-left">
                                            <i class="bx bx-user-circle text-2xl"></i>
                                        </div>
                                        <input type="text" name="name" id="name" spellcheck="false" autocomplete="off"
                                            [attr.disabled]="isRentalEnabledEditBooking == false?true:null"
                                            formControlName="name" required />
                                        <span>Name</span>
                                        <button class="input-icon-right"
                                            [disabled]="isRentalEnabledEditBooking == false"
                                            (click)="Global.roleJson.edit_booking['update'] == 1 ?searchCustomer(0,'name'):''">
                                            <i class="bx bx-search-alt text-2xl"></i>
                                        </button>
                                        <div style="clear: both;"></div>
                                    </div>
                                </div>
                                <div class="col-span-6 sm:col-span-3">
                                    <div class="cd-btn main-action custom-input-icon-2 w-full">
                                        <div class="input-icon-left">
                                            <i class="bx bx-phone text-2xl"></i>
                                        </div>
                                        <input type="text" name="phone" id="phone" spellcheck="false" autocomplete="off"
                                            pTooltip=" If you only input number we append
                                                                                    +{{Global.companyDetails.countryCode}} at the begin,
                                                                                    in case you wish to enter country code add
                                                                                    {{Global.companyDetails.countryCode}} space mobile number."
                                            tooltipPosition="top" tooltipStyleClass="tooltip-big-width"
                                            tooltipEvent="focus"
                                            [attr.disabled]="isRentalEnabledEditBooking == false?true:null"
                                            formControlName="phone" required />
                                        <span>Phone</span>
                                        <button class="input-icon-right"
                                            [disabled]="isRentalEnabledEditBooking == false"
                                            (click)="Global.roleJson.edit_booking['update'] == 1 ? searchCustomer(0,'phone'):''">
                                            <i class="bx bx-search-alt text-2xl"></i>
                                        </button>
                                        <div style="clear: both;"></div>
                                    </div>
                                </div>
                            </div>

                            <div class="cd-btn main-action custom-input-icon-left w-full h-14">
                                <div class="input-icon-left">
                                    <i class="bx bx-mail-send text-2xl"></i>
                                </div>
                                <input type="text" name="emailAddress" id="emailAddress" spellcheck="false"
                                    autocomplete="off" [attr.disabled]="isRentalEnabledEditBooking == false?true:null"
                                    formControlName="emailAddress" required />
                                <span>Email Address</span>
                                <div style="clear: both;"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="shadow-md boxBColor pr-2 pl-4 py-2 rounded-xl mt-2 mb-2 pb-4">
            <h3 class="fontMediumBold mb-1 capitalize px-3">Extras</h3>
            <div class="space-y-4">
                <div class="col-span-2 sm:col-span-3" *ngIf="Global.showNearestDriveOnCreateBooking == false">
                    <div class="mt-1 flex fontMediumBold h-14">
                        <span
                            class="inline-flex items-center px-3 rounded-l-full   custom-select Extras text-gray-500 text-xl fontMedium w-3/12">
                            AssignTo:
                        </span>
                        <select (change)="driverAssignTo($event)"
                            [attr.disabled]="isRentalEnabledEditBooking == false?true:null"
                            formControlName="editRideSetDriverId"
                            class="  boxBColor custom-select custom-font-md rounded-r-full p-2 w-full scroller  custom-select overflow-auto journal-scroll">
                            <option value="automatic" [selected]="Global.appMode == 1"> Automatic
                            </option>
                            <option value="manual" [selected]="Global.appMode == 0">
                                No One
                            </option>
                            <option *ngFor="let onlineDriver of onlineDriverList" [value]="onlineDriver.driverId">
                                {{onlineDriver.driverName}},{{onlineDriver.carTypeName}}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="col-span-2 sm:col-span-3" *ngIf="Global.showNearestDriveOnCreateBooking == true">
                    <div class="mt-1 flex fontMediumBold h-14">
                        <span
                            class="inline-flex items-center px-3 rounded-l-full   custom-select Extras text-gray-500 text-xl fontMedium w-3/12">
                            AssignTo:
                        </span>
                        <select (change)="driverAssignTo($event)"
                            [attr.disabled]="isRentalEnabledEditBooking == false?true:null"
                            formControlName="editRideSetDriverId"
                            class="  boxBColor custom-select custom-font-md rounded-r-full p-2 w-full scroller  custom-select overflow-auto journal-scroll">
                            <option value="automatic" [selected]="Global.appMode == 1"> Automatic
                            </option>
                            <option value="manual" [selected]="Global.appMode == 0">
                                No One
                            </option>
                            <option *ngFor="let onlineDriver of nearestDriverList" [value]="onlineDriver.driverId">
                                {{onlineDriver.driverName}},{{onlineDriver.carTypeName}}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="cd-btn main-action custom-input-icon-2 w-full h-14">
                    <div class="input-icon-left">
                        <i class="fas fa-tags text-2xl text-gray-400"></i>
                    </div>
                    <input type="text" [attr.disabled]="isRentalEnabledEditBooking == false?true:null"
                        #editBookingCouponCode name="editJobCouponCode" id="editJobCouponCode"
                        [ngClass]="{'rounded-r-full':((this.editRentalBookingForm.value.editBookingCouponCode | json) == ({} | json) && editJobCouponLoader)}"
                        [value]="(this.editRentalBookingForm.value.editBookingCouponCode | json) != ({} | json)? this.editRentalBookingForm.value.editBookingCouponCode.couponCode:''"
                        formControlName="editBookingCouponCode.couponCode" spellcheck="false"
                        [matAutocomplete]="editJobCouponList" (click)="getCoupon($event,'click')"
                        (input)="getCoupon($event,'onChange')" autocomplete="off" />
                    <span>Coupon</span>

                    <button class="input-icon-right cursor-pointer"
                        [attr.disabled]="isRentalEnabledEditBooking == false?true:null"
                        *ngIf="(this.editRentalBookingForm.value.editBookingCouponCode | json) != ({} | json) || !editJobCouponLoader">
                        <img [hidden]="editJobCouponLoader" src="assets/images/round-loder.gif"
                            class="w-8 h-8 rounded-full logoutLoader">
                        <button [hidden]="!editJobCouponLoader" [disabled]="isRentalEnabledEditBooking == false"
                            (click)="removeCouponCode()" class="fas fa-times-circle text-2xl text-red-400"></button>
                    </button>

                    <mat-autocomplete #editJobCouponList="matAutocomplete"
                        class="overflow-auto boxBColor journal-scroll">
                        <mat-option class="h-auto" *ngIf="editJobCouponDisplayDataList.length == 0">
                            <div class="flex flex-col justify-center w-11/12 truncate py-2">
                                <h5 class="text-xl autocomplete-head-label">
                                    Coupon not found.
                                </h5>
                            </div>
                        </mat-option>
                        <mat-option class="h-auto" *ngFor="let coupon of editJobCouponDisplayDataList;"
                            [value]="coupon.couponCode" (onSelectionChange)="selectCoupon(coupon)">
                            <div class="flex flex-col justify-center w-11/12 truncate">
                                <h5 class="text-xl autocomplete-head-label">
                                    {{coupon.couponTitle}}
                                </h5>
                                <p class="text-xl truncate m-0 fontMedium autocomplete-sub-label">
                                    {{coupon.couponCode}}
                                    (<span *ngIf="coupon.couponDiscountType != 1">Flat
                                        {{(editJobCurrency)?editJobCurrency:Global.currency}}
                                        {{coupon.couponDiscount}}
                                        discount</span>
                                    <span *ngIf="coupon.couponDiscountType == 1">{{coupon.couponDiscount}}%
                                        discount up to {{editJobCurrency}}
                                        {{coupon.couponMaxDiscount}}</span>)
                                </p>
                            </div>
                        </mat-option>
                    </mat-autocomplete>
                    <div style="clear: both;"></div>
                </div>

                <div class="max-w-full justify-items-center justify-center boxBColor  p-2 rounded-2xl tracking-wide">
                    <h1 class="text-9xl fontMediumBold font-bold mb-2 ml-3 font-medium">
                        <i class="fas fa-calculator mr-2"></i>Estimated
                    </h1>
                    <div class="fontColorDark custom-font-md ml-6">
                        <div class="w-full  grid grid-cols-4 items-center">
                            <div class="w-full ">
                                Amount
                            </div>
                            <div class="w-full">
                                :
                            </div>
                            <div class="w-full"></div>
                            <div
                                class="w-full flex items-center text-center justify-center custom_amount_input">
                                <input
                                    class=" boxBColor  custom-font-md p-2  scroller custom-select  w-full"
                                    name="triff_value"
                                    value="{{withoutSurgeEditJobCarRent}}"
                                    type="number"
                                    [disabled]="true" placeholder="0" />
                            </div>
                        </div>

                        <div class="w-full grid grid-cols-4 topBorder fontMediumBold font-bold fare-amount mt-2 mb-2">
                            <div class="w-full fontMediumBold font-bold fare-amount">
                                Sub Total
                            </div>
                            <div class="w-full">
                                :
                            </div>
                            <div class="w-full">

                            </div>
                            <div
                                class="w-full flex items-center text-center justify-center fontMediumBold font-bold fare-amount">
                                {{editJobCarRent}}
                            </div>
                        </div>
                        <div class="w-full grid grid-cols-4 ">
                            <div class="w-full">
                                Discount
                            </div>
                            <div class="w-full col-span-2 flex gap-2 items-center">
                                :
                                <div
                                    *ngIf="(this.editRentalBookingForm.value.editBookingCouponCode | json) != ({} | json)">
                                    <span
                                        *ngIf="this.editRentalBookingForm.value.editBookingCouponCode.couponCodeType != 1">
                                        flat
                                        {{(currency)?currency:Global.currency}}
                                        {{this.editRentalBookingForm.value.editBookingCouponCode.couponDiscount}}
                                        discount</span>
                                    <span
                                        *ngIf="this.editRentalBookingForm.value.editBookingCouponCode.couponCodeType == 1">
                                        {{this.editRentalBookingForm.value.editBookingCouponCode.couponCodeAmount}}%
                                        discount up to
                                        {{(currency)?currency:Global.currency}}
                                        {{this.editRentalBookingForm.value.editBookingCouponCode.couponCodeMaxAmount}}</span>
                                </div>
                            </div>
                            <div class="w-full flex items-center text-center justify-center">
                                -{{this.editJobDiscountAmount.toFixed(environment.priceRoundUpNumber)}}
                            </div>
                        </div>
                        <div class="w-full grid grid-cols-4">
                            <div class="w-full">
                                Tax Amount
                            </div>
                            <div class="w-full col-span-2 flex gap-2 items-center">
                                :
                            </div>
                            <div class="w-full flex items-center text-center justify-center ">
                                +{{editRideTax.toFixed(environment.priceRoundUpNumber)}}
                            </div>
                        </div>
                        <div class="w-full grid grid-cols-4">
                            <div class="w-full">
                                Arrears
                            </div>
                            <div class="w-full col-span-2 flex gap-2 items-center">
                                :
                            </div>
                            <div class="w-full flex items-center text-center justify-center">
                                +{{editRideArrears}}
                            </div>
                        </div>
                        <div class="w-full grid grid-cols-4 topBorder mt-2 fontMediumBold fare-amount font-bold">
                            <div class="w-full fontMediumBold font-bold fare-amount mt-2">
                                Total Fare
                            </div>
                            <div class="w-full col-span-2 flex gap-2 items-center">
                                :
                            </div>
                            <div
                                class="w-full flex items-center text-center justify-center fare-amount fontMediumBold font-bold mt-2">
                                {{editRideTotal.toFixed(environment.priceRoundUpNumber)}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-span-6 sm:col-span-6">
                    <div class="mt-1 flex fontMediumBold h-14">
                        <span
                            class="inline-flex items-center px-3 rounded-l-full   custom-select Extras text-gray-500 text-xl fontMedium w-7/12">
                            Flight#:
                        </span>
                        <input class="  boxBColor custom-select custom-font-md p-2 scroller  custom-select w-full"
                            name="flight" formControlName="editJobFlightNo"
                            [attr.disabled]="isRentalEnabledEditBooking == false?true:null" autocomplete="off"
                            placeholder="Enter Flight" type="text" />
                        <span
                            class="inline-flex items-center px-3   custom-select Extras text-gray-500 text-xl fontMedium">
                            Room#:
                        </span>
                        <input
                            class="  boxBColor custom-select custom-font-md p-2 rounded-r-full scroller  custom-select w-full"
                            name="room" formControlName="editJobRoomNo"
                            [attr.disabled]="isRentalEnabledEditBooking == false?true:null" autocomplete="off"
                            placeholder="Enter Room" type="text" />
                    </div>
                    <div *ngIf="isActiveBooking" class="col-span-6 sm:col-span-6 mt-4 inline-flex items-center justify-content-center w-full">
                        <button type="submit" class="custom-yellow-btn fontMedium"
                            *ngIf="Global.roleJson.delivered_booking['update'] == 1 && selectedBooking.bookingId != undefined && selectedBooking.bookingFlag == 1 && selectedBooking.bookingId !='' && (selectedBooking.status != 1 || (selectedBooking.status == 1 && selectedBooking.driverId != 'manual' && selectedBooking.driverId != 'automatic')) && selectedBooking.status != 6 && selectedBooking.paymentType != 2 && selectedBooking.isRestaurant != 1"
                            (click)="cancelBookingConfirmCall('deliveredJobByCash')"
                            >
                            <i class="fas fa-money-bill"></i> Delivered By Cash
                        </button>
                        <button type="submit" class="custom-yellow-btn fontMedium ml-2"
                            *ngIf="Global.roleJson.delivered_booking['update'] == 1 && selectedBooking.bookingId != undefined && selectedBooking.bookingFlag == 1 && selectedBooking.bookingId !='' && (selectedBooking.status != 1 || (selectedBooking.status == 1 && selectedBooking.driverId != 'manual' && selectedBooking.driverId != 'automatic')) && selectedBooking.status != 6"
                            (click)="cancelBookingConfirmCall('deliveredJobByCard')"
                            >
                            <i class="fas fa-credit-card"></i> Delivered By Card
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Account User Car list -->

    <!-- <p-dialog [(visible)]="isAccountUser" [modal]="true"  [style]="{position: 'absolute', width: '26vw', zIndex: '999999'}" [baseZIndex]="100000" [draggable]="false"
        [resizable]="false" (onHide)="onCancelClick()">
        <p-header> Select Account User Car </p-header>
        <div class="p-1 car_list_container overflow-y-scroll">
            <div *ngIf="showRentShimmer">
                <div class="custom_radio_style_list driver_details "
                    *ngFor="let car of editCarTypeRentArray; let i = index;">
                    <input id="car_id{{i}}" (click)="selectAccountCar(car)" name="radio" type="radio" />
                    <label for="car_id{{i}}"
                        [ngStyle]="{'border-left': '5px solid blue', 'background-color': carSelected === car ? '#d0e8ff' : 'transparent'}">
                        <li class="car">
                            <div class="pic">
                                <img class="" [src]="this.Global.setCarIcons(car.carSideIcon)" alt="" />
                            </div>
                            <div class="info">
                                <span class="fontMediumBold header"
                                    [ngStyle]="{'color': '#5E6DF4'}">{{car.carType}}</span>
                                <small class="fontMedium" [ngStyle]="{'color': '#5E6DF4'}"> {{car.carDescription
                                    }}</small>
                                <span class="info-price fontMediumBold">{{Global.currency}} {{
                                    car?.carRent?.toFixed(environment.priceRoundUpNumber)
                                    }}</span>
                            </div>
                        </li>
                    </label>
                </div>
            </div>

            <div id="container" *ngIf="!showRentShimmer">
                <div id="square" class="shimmer"></div>
                <div id="content">
                    <div id="title" class="shimmer"></div>
                    <div id="desc">
                        <div class="line shimmer"></div>
                        <div class="line shimmer"></div>
                        <div class="line shimmer"></div>
                        <div class="line shimmer"></div>
                    </div>
                </div>
            </div>

        </div>
        <ng-template pTemplate="footer">
            <button pButton pRipple type="submit" [hidden]="!editJobLoader" [disabled]="!editJobLoader"
                (click)="editRentalBookingCall()" label="Edit Booking"
                class="p-button-raised p-button-primery fontMedium p-button-text"></button>
            <div class="text-center justify-content-center flex input w-40 h-12" [hidden]="editJobLoader">
                <img class="profile-img" src="../../assets/images/loading.gif" alt="Workflow" />
            </div>
            <button pButton pRipple type="button" (click)="onCancelClick()" label="Cancel"
                class="p-button-raised p-button-text p-button-plain fontMedium">
            </button>
        </ng-template>
    </p-dialog> -->